import React from "react";

const BS5_Quiz = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Quiz Component</h2>
      <p>This is the BS5_Quiz component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Quiz;
